import en from "./data.json";
import es from "./data.es.json";

export const translations = { en, es };
export const LANGUAGES = ["en", "es"];
export const DEFAULT_LANGUAGE = "en";
